module.exports = require("./../../_gen/starling/textures/RenderTexture");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/textures/RenderTexture.js
// module id = 235
// module chunks = 0